import React from 'react';
import { Plugins } from '@leverege/plugin';
export const AggModelFactory = Plugins.createFactory('AggModel', {
  strategy: Plugins.LOOKUP,
  pluginKey: 'model'
});
export const AggViewModelFactory = Plugins.createFactory('AggViewModel', {
  strategy: Plugins.LOOKUP,
  pluginKey: 'model'
});
export const AggEditorFactory = Plugins.createFactory('AggEditor', {
  strategy: Plugins.reactStrategy(React, 'value'),
  pluginKey: 'editor'
});
export const AggViewFactory = Plugins.createFactory('AggView', {
  strategy: Plugins.reactStrategy(React, 'value'),
  pluginKey: 'view'
});
export const AggViewEditorFactory = Plugins.createFactory('AggViewEditor', {
  strategy: Plugins.reactStrategy(React, 'value'),
  pluginKey: 'editor'
});
export const AggClickActionFactory = Plugins.createFactory('AggClickAction', {
  strategy: Plugins.LOOKUP
});